module.exports = __webpack_public_path__ + "img/Modernisme_Bildekunst5.fca44272.jpg";